export default __webpack_public_path__ + "static/media/main.4dec8af5.png";